import type { TemplateStatusInfo } from '~/modules/campaign-template';

import { GI18NText } from '~/presentation/common';
import { useTranslation } from 'react-i18next';
import { ActionTemplate } from './common';
import { Text } from '@shopify/polaris';

interface DeletedTemplateContentProps {
  deletedTemplates: TemplateStatusInfo[];
  isDetailsScreen?: boolean;
  onEditCampaign: () => void;
}

export const DeletedTemplateContent = ({
  deletedTemplates,
  isDetailsScreen,
  onEditCampaign,
}: DeletedTemplateContentProps) => {
  const { t } = useTranslation();

  const hasOneDeletedTemplate = deletedTemplates.length === 1;

  const renderEditCampaignLink = (isMultiple?: boolean) => {
    const label = isMultiple
      ? 'Please go to [1]edit experiment[] and select another templates to ensure the experiment runs normally.'
      : 'Please go to [1]edit experiment[] and select another template to ensure the experiment runs normally.';

    return (
      <GI18NText
        as="span"
        variant="bodySm"
        transformers={{
          1: (text) => <ActionTemplate actionLabel={t(text)} onHandleAction={onEditCampaign} />,
        }}
      >
        {t(label)}
      </GI18NText>
    );
  };

  const getTextForEditScreen = (isMultiple?: boolean) => {
    const value = t('Please select other template to ensure the experiment runs normally.');

    if (isMultiple)
      return t('Please select other templates to ensure the experiment runs normally.');

    return (
      <Text as="span" variant="bodySm">
        {value}
      </Text>
    );
  };

  const getSuffixText = (isMultiple?: boolean) => {
    if (isDetailsScreen) return getTextForEditScreen(isMultiple);

    return renderEditCampaignLink(isMultiple);
  };

  if (hasOneDeletedTemplate) {
    const { name } = deletedTemplates[0];

    return (
      <>
        <GI18NText
          as="span"
          variant="bodyMd"
          transformers={{
            1: (text) => (
              <Text as="span" fontWeight="semibold" variant="bodyMd">
                {text}
              </Text>
            ),
          }}
        >
          {t('[1]"{{name}}"[] was deleted. ', { name })}
        </GI18NText>
        {getSuffixText()}
      </>
    );
  }

  return (
    <>
      <Text as="span" variant="bodyMd">
        {t(`Both tested templates were deleted. `)}
      </Text>
      {getSuffixText(true)}
    </>
  );
};
